import {inject, NgModule, provideAppInitializer} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {ApiAuthentInterceptor} from './core/interceptors/api-authent.interceptor';
import {AuthenticationService} from './core/services/authentication.service';
import {catchError, concat, forkJoin, of, switchMap, tap} from 'rxjs';
import {TranslationService} from './core/services/translation/translation.service';
import { NETWORK_STATUS } from './core/models/network-status.model';
import {NetworkService} from './core/services/network.service';
import {ToastContainerComponent} from './shared/components/toast/toast-container.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ToastContainerComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => {
      const authentService = inject(AuthenticationService);
      const translationService = inject(TranslationService);

      return authentService.initializeApp().pipe(
        catchError(err => {
          return of(null);
        }),
        switchMap(() => translationService.initializeTranslations())
      );
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiAuthentInterceptor,
      multi: true
    },
    {
      provide: NETWORK_STATUS,
      useClass: NetworkService
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
